import { useState } from "react";

export interface AddressInfoByPostalCode {
  postalCode: string;
  prefecture: string;
  city: string;
  address1: string;
}

interface ApiResponse {
  message: string;
  status: number;
  results: {
    zipcode: string;
    prefcode: string;
    address1: string;
    address2: string;
    address3: string;
    kana1: string;
    kana2: string;
    kana3: string;
  }[] | null
}

export const useAddressInfoByPostalCode = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [addressInfoList, setAddressInfoList] = useState<AddressInfoByPostalCode[]>([]);

  const getAddressInfoByPostalCode = async (postalCode: string): Promise<AddressInfoByPostalCode[]> => {
    setIsLoading(true);
    setError("");

    try {
      const url = new URL(`https://zipcloud.ibsnet.co.jp/api/search`);
      url.searchParams.set('zipcode', postalCode);
      const data: ApiResponse = await fetch(url).then((res) => res.json());

      // Check API status and message for proper error handling
      if (data.status !== 200) {
        setError(data.message || "APIエラーが発生しました。");
        setAddressInfoList([]);
        return [];
      }

      if (data.results === null) {
        setAddressInfoList([]);
        return [];
      }

      const addressList = data.results.map(item => {
        return {
          postalCode: item.zipcode,
          prefecture: item.address1,
          city: item.address2,
          address1: item.address3,
        };
      });
      setAddressInfoList(addressList);
      return addressList;
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err));
      setError(error.message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { getAddressInfoByPostalCode, isLoading, error, addressInfoList };
};
